/* LarpLife theme — reads catalog.json (vendor names only, no supplier URLs)
   and wires the nav, stats, category counts, product vendor list and directory. */

(function () {
  'use strict';

  /* Honour the OS "reduce motion" setting everywhere below. */
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var fmt = function (n) { return Number(n).toLocaleString('en-GB'); };
  var esc = function (s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  };

  var LOCK =
    '<span class="vlock"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" ' +
    'stroke-linejoin="round" aria-hidden="true"><rect x="4.8" y="10.6" width="14.4" height="9.6" rx="1.4"/>' +
    '<path d="M8.2 10.6V7.8a3.8 3.8 0 0 1 7.6 0v2.8"/></svg>Locked</span>';

  /* ------------------------------------------------------------- chrome -- */
  function initChrome() {
    var toggle = document.querySelector('.nav-toggle');
    var links = document.querySelector('.nav-links');
    if (toggle && links) {
      toggle.addEventListener('click', function () {
        var open = links.classList.toggle('open');
        toggle.setAttribute('aria-expanded', String(open));
      });
    }
  }

  /* Product handles look like "larplife-clothing"; catalog slugs like "clothing".
     Shopify auto-generates handles from titles if one is ever left unset
     ("clothing-supplier-links"), so strip both shapes rather than assuming one. */
  function slugFromHandle(handle) {
    return String(handle || '')
      .replace(/^larplife-/, '')
      .replace(/-supplier-links$/, '');
  }

  /* --------------------------------------------------------------- data -- */
  function loadCatalog() {
    var url = (window.LARPLIFE && window.LARPLIFE.catalogUrl) || '';
    if (!url) return Promise.reject(new Error('no catalog url'));
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error('catalog ' + r.status);
      return r.json();
    });
  }

  /* -------------------------------------------------------------- stats -- */
  function fillStats(cat) {
    document.querySelectorAll('[data-stat]').forEach(function (el) {
      var k = el.getAttribute('data-stat');
      var v = k === 'vendors'    ? cat.totalVendors
            : k === 'suppliers'  ? cat.uniqueSuppliers
            : k === 'categories' ? cat.categories.length
            : null;
      if (v !== null) setNumber(el, v);
    });
  }

  /* Counts up to the figure once it scrolls into view. The final value is written
     immediately for reduced-motion users and where IntersectionObserver is absent,
     so the number is never left blank or mid-count. */
  function setNumber(el, value) {
    if (REDUCED || !('IntersectionObserver' in window)) { el.textContent = fmt(value); return; }

    el.textContent = fmt(0);
    var run = function () {
      var start = null, DUR = 1100;
      var step = function (ts) {
        if (start === null) start = ts;
        var t = Math.min((ts - start) / DUR, 1);
        var eased = 1 - Math.pow(1 - t, 3);            // ease-out cubic
        el.textContent = fmt(Math.round(value * eased));
        if (t < 1) requestAnimationFrame(step);
        else el.textContent = fmt(value);
      };
      requestAnimationFrame(step);
    };

    var started = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        started = true;
        run();
      });
    }, { threshold: 0.4 });
    io.observe(el);

    /* Safety net: the figure is the content, not the animation. If the observer
       never fires, show the real number rather than leaving a zero on screen. */
    setTimeout(function () { if (!started) el.textContent = fmt(value); }, 2500);
  }

  /* ------------------------------------------------- category card counts -- */
  function fillCounts(cat) {
    var bySlug = {};
    cat.categories.forEach(function (c) { bySlug[c.slug] = c; });

    document.querySelectorAll('.cat-card[data-handle]').forEach(function (card) {
      var c = bySlug[slugFromHandle(card.getAttribute('data-handle'))];
      var el = card.querySelector('[data-count]');
      if (!el) return;
      el.textContent = c ? fmt(c.count) + ' listings' : 'All categories';
    });

    var meta = document.querySelector('[data-buy-meta]');
    if (meta) {
      var c = bySlug[slugFromHandle(meta.getAttribute('data-handle'))];
      if (c) meta.textContent = fmt(c.count) + ' supplier links · one-off · instant delivery';
      else meta.textContent = fmt(cat.totalVendors) + ' supplier links · one-off · instant delivery';
    }
  }

  /* ------------------------------------------- product page vendor list -- */
  function initProductList(cat) {
    var listEl = document.getElementById('ProductVendorList');
    if (!listEl) return;
    if (!REDUCED) listEl.classList.add('vlist-anim');

    var slug = slugFromHandle(listEl.getAttribute('data-handle'));
    var entry = cat.categories.filter(function (c) { return c.slug === slug; })[0];

    // all-access product: show every vendor, tagged with its category
    var rows = entry
      ? entry.vendors.map(function (v) { return { name: v, cat: entry.name }; })
      : cat.categories.reduce(function (acc, c) {
          return acc.concat(c.vendors.map(function (v) { return { name: v, cat: c.name }; }));
        }, []).sort(function (a, b) { return a.name.localeCompare(b.name); });

    var searchEl = document.getElementById('ProductVendorSearch');
    var countEl = document.getElementById('ProductVendorCount');
    var LIMIT = 400;

    function render() {
      var q = (searchEl && searchEl.value || '').trim().toLowerCase();
      var items = q ? rows.filter(function (r) { return r.name.toLowerCase().indexOf(q) !== -1; }) : rows;

      if (countEl) countEl.textContent = fmt(items.length) + ' / ' + fmt(rows.length);

      if (!items.length) {
        listEl.innerHTML = '<div class="empty">Nothing matches that search.</div>';
        return;
      }

      var shown = items.slice(0, LIMIT);
      listEl.innerHTML = shown.map(function (r, i) {
        return '<div class="vrow" style="--i:' + Math.min(i, 24) + '"><span class="vname">' + esc(r.name) + '</span>' +
               '<span class="vcat">' + esc(r.cat) + '</span>' + LOCK + '</div>';
      }).join('') +
      (items.length > LIMIT
        ? '<div class="empty">+ ' + fmt(items.length - LIMIT) + ' more — search to narrow the list.</div>'
        : '');
    }

    if (searchEl) {
      var t;
      searchEl.addEventListener('input', function () {
        clearTimeout(t); t = setTimeout(render, 120);
      });
    }
    render();
  }

  /* ---------------------------------------------------- directory page -- */
  function initDirectory(cat) {
    var listEl = document.getElementById('DirList');
    if (!listEl) return;
    if (!REDUCED) listEl.classList.add('vlist-anim');

    var searchEl = document.getElementById('DirSearch');
    var filterEl = document.getElementById('DirFilter');
    var countEl = document.getElementById('DirCount');
    var moreEl = document.getElementById('DirMore');
    var moreWrap = document.getElementById('DirMoreWrap');
    var PAGE = 120;
    var shown = PAGE;

    if (filterEl) {
      filterEl.innerHTML = '<option value="">All categories</option>' +
        cat.categories.map(function (c) {
          return '<option value="' + esc(c.slug) + '">' + esc(c.name) + ' (' + fmt(c.count) + ')</option>';
        }).join('');
    }

    var rows = cat.categories.reduce(function (acc, c) {
      return acc.concat(c.vendors.map(function (v) { return { name: v, cat: c.name, slug: c.slug }; }));
    }, []).sort(function (a, b) { return a.name.localeCompare(b.name); });

    function filtered() {
      var q = (searchEl && searchEl.value || '').trim().toLowerCase();
      var f = filterEl ? filterEl.value : '';
      return rows.filter(function (r) {
        return (!f || r.slug === f) && (!q || r.name.toLowerCase().indexOf(q) !== -1);
      });
    }

    function render() {
      var items = filtered();
      if (countEl) countEl.textContent = fmt(items.length) + ' / ' + fmt(rows.length);

      if (!items.length) {
        listEl.innerHTML = '<div class="empty">No vendors match that search.</div>';
        if (moreWrap) moreWrap.hidden = true;
        return;
      }

      listEl.innerHTML = items.slice(0, shown).map(function (r, i) {
        return '<div class="vrow" style="--i:' + Math.min(i, 24) + '"><span class="vname">' + esc(r.name) + '</span>' +
               '<span class="vcat">' + esc(r.cat) + '</span>' + LOCK + '</div>';
      }).join('');

      var remaining = items.length - shown;
      if (moreWrap) moreWrap.hidden = remaining <= 0;
      if (moreEl && remaining > 0) {
        moreEl.textContent = 'Show ' + fmt(Math.min(remaining, PAGE)) + ' more';
      }
    }

    if (searchEl) {
      var t;
      searchEl.addEventListener('input', function () {
        clearTimeout(t); t = setTimeout(function () { shown = PAGE; render(); }, 120);
      });
    }
    if (filterEl) filterEl.addEventListener('change', function () { shown = PAGE; render(); });
    if (moreEl) moreEl.addEventListener('click', function () { shown += PAGE; render(); });

    render();
  }

  /* ------------------------------------------------------------ motion -- */
  /* Reveal-on-scroll. The hiding class is applied by JS and never sits in the
     stylesheet, so with JS off or broken every section renders normally rather
     than staying invisible. */
  var REVEAL_TARGETS = [
    '.stat-strip .stat',
    '.cat-card',
    '.step',
    '.faq details',
    '.review',
    '.price-card',
    '.section-head'
  ].join(', ');

  function initReveal() {
    if (REDUCED || !('IntersectionObserver' in window)) return;

    var els = [].slice.call(document.querySelectorAll(REVEAL_TARGETS));
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        e.target.classList.add('is-in');
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el, i) {
      el.classList.add('reveal');
      /* Stagger only within a row of siblings, so a long list does not end up
         with a two-second delay on its last item. */
      var sibs = el.parentNode ? [].slice.call(el.parentNode.children).indexOf(el) : 0;
      el.style.setProperty('--reveal-delay', (Math.min(sibs, 5) * 70) + 'ms');
      io.observe(el);
    });
  }

  /* Condense the header once the page has moved off the top. */
  function initHeaderScroll() {
    var nav = document.querySelector('.nav');
    if (!nav) return;
    var ticking = false;
    var apply = function () {
      nav.classList.toggle('nav--scrolled', window.pageYOffset > 24);
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }, { passive: true });
    apply();
  }

  /* A hairline gold progress bar across the top of the viewport. */
  function initScrollProgress() {
    if (REDUCED) return;
    var bar = document.createElement('div');
    bar.className = 'scroll-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);

    var ticking = false;
    var update = function () {
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      var p = max > 0 ? Math.min(window.pageYOffset / max, 1) : 0;
      bar.style.transform = 'scaleX(' + p + ')';
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* A pool of warm light that follows the cursor across a category card.
     Pointer-driven only, so touch devices never pay for the listener. */
  function initSpotlight() {
    if (REDUCED) return;
    if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

    var cards = document.querySelectorAll('.cat-card');
    if (!cards.length) return;

    cards.forEach(function (card) {
      var queued = false, lastX = 0, lastY = 0;
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        lastX = e.clientX - r.left;
        lastY = e.clientY - r.top;
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () {
          card.style.setProperty('--mx', lastX + 'px');
          card.style.setProperty('--my', lastY + 'px');
          queued = false;
        });
      }, { passive: true });
    });
  }

  function initMotion() {
    document.documentElement.classList.add('js');
    initHeaderScroll();
    initReveal();
    initScrollProgress();
    initSpotlight();
  }

  /* ---------------------------------------------------------------- go -- */
  /* Every consumer of catalog.json. Policy and cart pages have none, so they
     should not pay for a 25 KB fetch they will never read. */
  var CATALOG_CONSUMERS = '[data-stat], .cat-card[data-handle], [data-buy-meta], #ProductVendorList, #DirList';

  function boot() {
    initChrome();
    initMotion();

    if (!document.querySelector(CATALOG_CONSUMERS)) return;

    loadCatalog().then(function (cat) {
      fillStats(cat);
      fillCounts(cat);
      initProductList(cat);
      initDirectory(cat);
    }).catch(function (err) {
      console.error('[LarpLife]', err);
      var d = document.getElementById('DirList');
      if (d) d.innerHTML = '<div class="empty">Directory data unavailable.</div>';
      var p = document.getElementById('ProductVendorList');
      if (p) p.innerHTML = '<div class="empty">Vendor list unavailable.</div>';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
